import { injectCssPropertiesIntoRootElementMutatorFactory } from './inject-css-properties-into-root-element';
import { elementMutatorFactory } from './element-mutator';
import { getStyleProp } from './css-property-utils';
export var listPropsInjectorFactory = function (_a) {
    var props = _a.props, experiments = _a.experiments;
    var rootElementObject = {
        padding: '0',
        'margin-top': 0,
        'margin-right': 0,
        'margin-bottom': 0,
        'margin-left': 0,
    };
    var mutators = [
        injectCssPropertiesIntoRootElementMutatorFactory(rootElementObject, experiments),
    ];
    if (!(experiments['specs.so.lp.ListStyleInside'] === 'true')) {
        mutators.push(elementMutatorFactory(function ($el) {
            var multiplier = $el.is('ol') ? 1.4 : 1;
            var paddingSize = Math.max(parseInt(getStyleProp($el, 'font-size', {}) || props.fontSize, 10), 20);
            var isRtl = $el.is('[dir="rtl"]');
            var paddingLeft = isRtl ? 0 : paddingSize;
            var paddingRight = isRtl ? paddingSize : 0;
            $el.css('padding-left', paddingLeft * multiplier + "px");
            $el.css('padding-right', paddingRight * multiplier + "px");
        }));
    }
    else {
        mutators.push(elementMutatorFactory(function ($el) {
            var isRtl = $el.is('[dir="rtl"]');
            var paddingLeft = isRtl ? 0 : 24;
            var paddingRight = isRtl ? 24 : 0;
            $el.css('padding-left', paddingLeft + "px");
            $el.css('padding-right', paddingRight + "px");
        }));
    }
    return {
        elements: ['ol', 'ul'],
        mutators: mutators,
    };
};
//# sourceMappingURL=inject-missing-list-props.js.map